import { render, staticRenderFns } from "./debtorView.vue?vue&type=template&id=388396fc&"
import script from "./debtorView.vue?vue&type=script&lang=js&"
export * from "./debtorView.vue?vue&type=script&lang=js&"
import style0 from "./debtorView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports